var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('errorHeader'),_c('div',{staticClass:"title"},[_vm._v("企业微信扫描登录")]),_c('div',{staticClass:"iframe_box"},[_c('iframe',{attrs:{"src":_vm.webLogin,"frameborder":"0"}})]),_c('copyFooter',{attrs:{"color":"#000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }